import React from 'react';

/**
 * 検索フォームの要素
 *
 * @param {*} { label, children, eleClass }
 */
export const SearchFormElement = ({ label, children, eleClass }) => (
  <div className='form-element'>
    <div className='form-element__label'>
      <span className='label'>{label}</span>
    </div>
    <div className={eleClass}>{children}</div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/forms/SearchFormElement.jsx